import Activities from '@/components/Activities'
import { getContractCustomerActivities } from '@/modules/Contract/services/customer'

const ActionLog = () => {
    return (
        <Activities
            className="!mt-0"
            apiCall={getContractCustomerActivities}
            queryKey="contracts.customers"
        />
    )
}

export default ActionLog
